//
//
//
//
//
//
//
//

import { defineComponent } from '@vue/composition-api';

import ErrorTemplate from '~/components/errorTemplate.vue';

export default defineComponent({
  components: { ErrorTemplate },
  layout: 'error',
  props: ['error'],
});
